// ===========================================================================
// CDCI v2 — constantes del módulo.
//
// El v2 existe para REFACTORIZAR LA TRANSCRIPCIÓN (AI Scribe) sin tocar el
// CDCI productivo: re-exporta TODAS las constantes del v1 y pisa solo las que
// distinguen al módulo (path y nombre). Las páginas duplicadas importan
// `../common/constants` y, gracias a esto, navegan dentro de /cdci-v2 sin
// cambiar ninguna otra línea.
//
// Regla de ESM: un export local con el mismo nombre PISA al del `export *` —
// por eso CDCI_BASE_PATH y CDCI_FULL_NAME quedan redefinidos sin conflicto.
// ===========================================================================
export * from "../../cdci/common/constants";

/**
 * Gate de entorno: el v2 es un banco de trabajo del refactor del transcriptor
 * (docs/modulos/AIScribe/) — NO debe verse en producción hasta que reemplace
 * al v1. Mismo patrón que PLAYGROUND_ENABLED / TRANSCRIPTOR_ENABLED: gobierna
 * las rutas (index.js exporta [] si está apagado) y el ítem del sidebar.
 */
export const CDCI_V2_ENABLED = process.env.NODE_ENV === "development";

export const CDCI_BASE_PATH = "/cdci-v2";

// El sufijo v2 se muestra a propósito: en dev conviven los dos módulos y el
// header tiene que decir en cuál se está parado.
export const CDCI_FULL_NAME = "Clinical Documentation & Charge Intelligence (v2)";
